/* eslint-disable global-require */

import angular from 'angular';
import FormWrapController from './form-wrap.controller';

const VehicleFormWrapComponent = {
  selector: 'vehicleFormsWrap',
  bindings: {
    overlay: '=',
    vehicle: '=',
    exitForm: '&',
    dummyVehicle: '=',
  },
  controllerAs: '$ctrl',
  controller: FormWrapController,
  template: /* html */ `
    <bd-overlay class="fade" ng-show="$ctrl.overlay.visiblity" ng-cloak>
      <bd-overlay-title title="{{ $ctrl.overlay.title }}" exit="$ctrl.exitForm({ removeLock: true })"></bd-overlay-title>

      <bd-overlay-content>
        <bd-overlay-preloader
          ng-if="false"
          title="Das Fahrzeug wird für alle anderen Benutzer gesperrt."
        ></bd-overlay-preloader>

        <vehicle-online-check
          ng-if="$ctrl.onlineCheck"
          [check]="$ctrl.onlineCheck"
          [vehicle-id]="vehicle._id"
        ></vehicle-online-check>

        <form-datasheet
          ng-if="$ctrl.overlay.action === 'datasheet' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'datasheet'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-datasheet>

        <form-pricing-sticker
          ng-if="$ctrl.overlay.action === 'pricing_sticker' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'pricing_sticker'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-pricing-sticker>

        <form-registration
          ng-if="$ctrl.overlay.action === 'registration' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'registration'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-registration>

        <form-battery-health
          ng-if="$ctrl.overlay.action === 'battery_health' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'battery_health'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-battery-health>

        <form-delivery
          ng-if="$ctrl.overlay.action === 'delivery' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'delivery'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-delivery>

        <form-handover
          ng-if="$ctrl.overlay.action === 'handover' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'handover'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-handover>

        <form-location
          ng-if="$ctrl.overlay.action === 'location' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'location'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-location>

        <form-pricing
          ng-if="$ctrl.overlay.action === 'pricing' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'pricing'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
          dummy-vehicle="$ctrl.dummyVehicle"
        ></form-pricing>

        <form-mileage
          ng-if="$ctrl.overlay.action === 'mileage' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'mileage'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-mileage>

        <form-remove-availability
          ng-if="$ctrl.overlay.action === 'remove_state' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'remove_state'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-remove-availability>

        <form-availability
          ng-if="$ctrl.overlay.action === 'state' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'state'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
          customer-id="$ctrl.overlay.customerId"
        ></form-availability>

        <form-custom-template
          ng-if="$ctrl.overlay.action === 'custom-template' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'custom-template'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
          customer-id="$ctrl.overlay.customerId"
        ></form-custom-template>

        <form-opportunity
          ng-if="$ctrl.overlay.action === 'opportunity' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'opportunity'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-opportunity>

        <form-online-platforms
          ng-if="$ctrl.overlay.action === 'platforms' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'platforms'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-online-platforms>

        <form-offer
          ng-if="$ctrl.overlay.action === 'offer' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'offer'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
          customer-id="$ctrl.overlay.customerId"
          dummy-vehicle="$ctrl.dummyVehicle"
        ></form-offer>

        <form-upload-file
          ng-if="$ctrl.overlay.action === 'upload_file' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'upload_file'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          identifier="{{ $ctrl.vehicle._id }}"
          section="vehicle"
        ></form-upload-file>

        <form-upload-image
          ng-if="$ctrl.overlay.action === 'upload_images' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'upload_images'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-upload-image>

        <form-upload-panoramic
          ng-if="$ctrl.overlay.action === 'upload_panoramic' && $ctrl.loadForm"
          show="$ctrl.overlay.action === 'upload_panoramic'"
          exit="$ctrl.exitForm({removeLock, redirect})"
          vehicle="$ctrl.vehicle"
        ></form-upload-panoramic>
      </bd-overlay-content>
    </bd-overlay>
  `,
};

export default angular.module('autoboard.vehicleFormWrap', [])
  .component(VehicleFormWrapComponent.selector, VehicleFormWrapComponent)
  .name;
